import axios from "axios";

const MY_SERVER = '/api/'

export function comfortTrue(gender, player, usedid, sessionid) {
    
    return axios
        .get(MY_SERVER + 'randomtruebygender/', {
            params: { gender, player, usedid, sessionid },
            withCredentials: true,
        })
        .then((res) => res.data) // ✅ Directly return the response data
        .catch((error) => {
            console.error('Error fetching dare:', error);
            throw error; // ✅ Ensure error is thrown for handling
        });
}